import axios from 'axios';

const API_ENDPOINT = '/.netlify/functions/openai';

export const getTaxAdvice = async (earnings) => {
  try {
    const response = await axios.post(API_ENDPOINT, {
      prompt: `my crypto earnings were ${earnings}$ in United States. what is my tax liability? Please provide a brief, clear explanation focusing on federal and state tax rates, and the approximate total tax amount. Format the response to be displayed on a website.`
    });
    return response.data.response;
  } catch (error) {
    console.error('Failed to get tax advice:', error);
    throw new Error('Failed to get AI tax analysis');
  }
};
